import React from 'react';
import {Button, Tooltip} from '@mantine/core';
import { IconPin } from '@tabler/icons-react';
import { useLocalStorage } from '@mantine/hooks';
import {useLocation, useParams} from "react-router-dom";
import {AimModules, PinnedTab} from "@repo/services";
import {errorBoundaryWrapper} from "@repo/utils";

const PinnedTabsButton = ({ module, title }: { module: AimModules, title: string }) => {
    const location = useLocation();
    const [pinnedTabs, setPinnedTabs] = useLocalStorage<PinnedTab[]>({
        key: 'pinned-tabs',
        defaultValue: []
    });
    const containsRoute = () => {
        const normalizedCurrentPath = location?.pathname?.replace(/\/+$/, '');
        return pinnedTabs.some((tab) => tab.route === normalizedCurrentPath);
    }
    return (
        <Tooltip label="Pin This Page">
            <Button
                mr={8}
                variant='default'
                disabled={containsRoute()}
                onClick={() => {
                    const currentTabs = [...pinnedTabs];
                    const currentLocation = location.pathname;
                    const newTab: PinnedTab = {
                        name: title,
                        module: module,
                        route: currentLocation
                    }
                    const updatedTabs = [...currentTabs, newTab];
                    setPinnedTabs(updatedTabs);
                }}
            >
                <IconPin />
            </Button>
        </Tooltip>
    );
};

export default errorBoundaryWrapper(PinnedTabsButton);
